import * as React from 'react';
import styled from '@emotion/styled';

const SvgWrapper = styled('svg', { label: 'SvgWrapper' })`
    background-color: #a3ccb2;
    height: 32px;
    width: 32px;
    padding: 9px;
    margin-right: 6px;
`;

export const ExportIcon = (): React.ReactElement => (
    <SvgWrapper width={14} height={24} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none' fillRule='evenodd' stroke='#FFF' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2'>
            <path d='M18.667 13.111v6.667A2.222 2.222 0 0 1 16.444 22H4.222A2.222 2.222 0 0 1 2 19.778V7.556c0-1.228.995-2.223 2.222-2.223h6.667M15.333 2H22v6.667M9.778 14.222L22 2'/>
        </g>
    </SvgWrapper>
);


